import React from 'react';
import type { FlexProps } from '@withjoy/joykit';
import { TextV2, Flex } from '@withjoy/joykit';
import { useTranslation } from '@shared/core';

interface FreeShippingInlineBannerProps extends FlexProps {
  countriesWithFreeShipping: string[];
}

export const FreeShippingInlineBanner = ({ countriesWithFreeShipping, ...props }: FreeShippingInlineBannerProps) => {
  const { tq } = useTranslation('stationery');

  if (countriesWithFreeShipping.length === 0) {
    return null;
  }

  return (
    <Flex
      justifyContent="center"
      {...props}
    >
      <TextV2
        typographyVariant="button1"
        color="#4951EF"
      >
        {tq`Free Shipping to ${countriesWithFreeShipping.join(', ')} Addresses`}
      </TextV2>
    </Flex>
  );
};
